import { takeLatest } from 'redux-saga/effects';
import { docInstActions } from './reducer';
import { all, put } from 'redux-saga/effects';
import { call } from 'redux-saga/effects';
import { apiCall } from './../app/config';
import { AxiosResponse } from "axios";


function* requestDocListWorker() {
  try {
    const res: AxiosResponse = yield call(apiCall, {
      url: '/portalrh/documentos',
      method: 'get'
    })
    console.log('documentos retornados', res.data)

    yield put(docInstActions.requestDocListSuccess(res.data))
  } catch (error: any) {
    console.log('error',error)
    yield put(docInstActions.requestDocListError(
      error?.response?.data?.message ? error.response?.data?.message : JSON.stringify(error)
    ))
  }
}

export function* docInstSaga() {
  yield all([
    takeLatest("docInst/requestDocList", requestDocListWorker)
  ])
}